<template>
    <tr>
        <td>{{setting.title}}</td>
        <td>{{setting.description}}</td>
        <td>{{setting.setting_name}}</td>
        <td>{{setting.setting_value}}</td>
        <td>
            <div class="buttons">
                <div class="edit"><span class="material-icons" data-toggle="modal" :data-target="'#setting-'+setting.id">edit</span></div>
                <div class="delete"><span class="material-icons" @click="destroy()">clear</span></div>
            </div>
        </td>
        <div class="modal fade" tabindex="-1"  :id="'setting-'+setting.id" ref="vuemodal">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header bg-primary text-white">
                        <h5 class="modal-title">Iestatījuma labošana</h5>
                        <button type="button" class="close text-white" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">

                        <div class="row">
                            <div class="col-12">
                                <div class="form-group">
                                    <label for="title">Publiskais nosaukums</label>
                                    <input autocomplete="off" id="title" type="text" v-model="title" class="form-control" :class="{'is-invalid':errors && ( 'title' in errors)}">
                                    <small class="text-danger" v-if="errors && errors.title">{{errors.title[0]}}</small>
                                </div>
                                <div class="form-group">
                                    <label for="description">Apraksts</label>
                                    <input autocomplete="off" id="description" type="text" v-model="description" class="form-control" :class="{'is-invalid':errors && ( 'description' in errors)}">
                                    <small class="text-danger" v-if="errors && errors.description">{{errors.description[0]}}</small>
                                </div>
                                <div class="form-group">
                                    <label for="setting_name">Iestatījuma nosaukums</label>
                                    <input autocomplete="off" id="setting_name" type="text" v-model="setting_name" class="form-control" :class="{'is-invalid':errors && ( 'setting_name' in errors)}">
                                    <small class="text-danger" v-if="errors && errors.setting_name">{{errors.setting_name[0]}}</small>
                                </div>
                                <div class="form-group">
                                    <label for="setting_value">Iestatījuma vērtība</label>
                                    <input autocomplete="off" id="setting_value" type="text" v-model="setting_value" class="form-control" :class="{'is-invalid':errors && ( 'setting_value' in errors)}">
                                    <small class="text-danger" v-if="errors && errors.setting_value">{{errors.setting_value[0]}}</small>
                                </div>

                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <input type="button" class="btn btn-primary" value="Saglabāt" v-if="loading === false" @click="update()">
                        <button type="button" class="btn btn-primary"  v-if="loading === true"><i class="fas fa-spinner fa-spin"></i></button>
                    </div>
                </div>
            </div>
        </div>
    </tr>
</template>

<script>
export default{
    props:['setting'],
    mounted()
    {
      this.title = this.$props.setting.title;
      this.description = this.$props.setting.description;
      this.setting_name = this.$props.setting.setting_name;
      this.setting_value = this.$props.setting.setting_value;
    },
    data()
    {
        return {
            title:"",
            description:"",
            setting_name:"",
            setting_value:"",
            loading:false,
            errors:[],
        }
    },
    methods:{
        destroy()
        {
            var that = this;
            this.$swal.fire({
                title: 'Vai tiešām vēlaties dzēst iestatījumu?',
                text: "Iestatījuma dzēšana var ietekmēt visas sistēmas darbību.",
                icon: 'question',
                showCancelButton: true,
                confirmButtonText: 'Jā',
                cancelButtonText: 'Atcelt'
            }).then((result) => {
                if (result.value) {
                    axios.post('/settings/delete/' + this.$props.setting.id).then(response => {
                        if (response.data.status === 'success') {
                            that.$toast.open(response.data.message);
                            EventBus.$emit('settings_list_update', response.data.settings);
                        }
                        if (response.data.status === 'error') {
                            that.$toast.error(response.data.message);
                            that.errors = response.data.errors;
                        }
                        that.loading = false;
                    });
                }
            });
        },
        update() {
            var that = this;
            this.loading = true;
            this.errors = [],
                axios.post('/settings/update/'+this.$props.setting.id,{
                    title:this.title,
                    description:this.description,
                    setting_name:this.setting_name,
                    setting_value:this.setting_value
                }).then(response =>{
                    if(response.data.status === 'success')
                    {
                        that.$toast.open(response.data.message);
                        EventBus.$emit('settings_list_update', response.data.settings);
                        $(that.$refs.vuemodal).modal('hide');
                    }
                    if (response.data.status === 'error')
                    {
                        that.$toast.error(response.data.message);
                        that.errors = response.data.errors;
                    }
                    that.loading = false;
                });
        }
    }
}
</script>

<style lang="scss" scoped>
    .material-icons{
        cursor: pointer;
    }
    .buttons{
        display:flex;
        >div{
            margin:10px;
            &.delete{
                display:flex;
                align-items: center;
                justify-content: center;
                cursor:pointer;
                width:24px;
                height:24px;
                background-color:#DC3545;
                color:#fff;
                transition:all .2s ease-in-out;
                border-radius:100%;

            }
        }
    }
</style>
